export enum STATUS {
  Alert = 'alert',
  Regular = 'regular',
  Success = 'success',
}
